// IMPORT
import { RepositoryFactory } from '@/api/RepositoryFactory'
const api = RepositoryFactory.get('approvements')

// MUTATIONS CONSTANTS
const FETCH_APPROVEMENTS = 'FETCH_APPROVEMENTS'
const SET_LOADING = 'SET_LOADING'

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
  },
  getters: {
    totalCount: ({ list }) => {
      let total = 0
      const drivers = list.find(c => c.rel === 'drivers')
      const automobiles = list.find(c => c.rel === 'automobiles')
      const contragents = list.find(c => c.rel === 'contragents')

      if (drivers) {
        const count = drivers?.stats?.by_meaning?.waiting || 0

        total += count
      }
      if (automobiles) {
        const count = automobiles?.stats?.by_meaning?.waiting || 0

        total += count
      }
      if (contragents) {
        const count = contragents?.stats?.by_meaning.waiting

        total += count
      }

      return total
    },
  },
  mutations: {
    [SET_LOADING](state, payload) {
      state.loading = Boolean(payload)
    },
    [FETCH_APPROVEMENTS](state, payload) {
      state.list = payload
    },
  },
  actions: {
    async fetchApprovements({ commit }) {
      try {
        commit(SET_LOADING, true)
        const { data } = await api.fetchApprovements()

        commit(FETCH_APPROVEMENTS, data)
      } catch (error) {
        console.log(`error fetch approvements: `, error)
      } finally {
        commit(SET_LOADING, false)
      }
    },
  },
}
